import { useEffect, useState } from "react";

const navLinks = [
  { href: "#home", label: "首页" },
  { href: "#features", label: "核心功能" },
  { href: "#anime", label: "热门番剧" },
  { href: "#guide", label: "线路指南" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/90 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="container-site flex h-[72px] items-center justify-between">
        <a
          href="#home"
          className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950"
          aria-label="小猴看番 首页"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-xl text-background-50">
            <i className="ri-clapperboard-line" aria-hidden="true"></i>
          </span>
          <span className="text-primary-600">小猴看番</span>
        </a>

        <nav className="hidden items-center gap-8 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a href="#anime" className="btn-primary text-sm">
            立即看番
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50/95 backdrop-blur-md md:hidden">
          <nav className="container-site flex flex-col gap-1 py-4" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a href="#anime" onClick={() => setMenuOpen(false)} className="btn-primary mt-2 w-full">
              立即看番
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}